'use client';

import type { ReactNode } from 'react';

import useDarkMode from '@/utils/hooks/utils/useDarkMode';

import { NO_BACKGROUND_BLACK } from '@/components/base/Dropdown';
import Iconosquare from '@/components/icons/Iconosquare';
import EmailUpdateConfirmationSuccessModal from '@/components/pages/settings/EmailUpdateConfirmationSuccessModal';
import SwitchLanguage from '@/components/pages/signup/SwitchLanguage';

type LayoutSignInProps = {
    children: ReactNode;
    emailUpdated?: boolean;
};

const LayoutSignIn = ({ children, emailUpdated = false }: LayoutSignInProps) => {
    const { useRemoveDarkMode } = useDarkMode();
    useRemoveDarkMode();

    return (
        <div className="relative flex">
            {emailUpdated ? <EmailUpdateConfirmationSuccessModal /> : null}
            <div className="h-screen w-full">
                <div className="absolute inset-0 -z-1 h-screen w-screen overflow-hidden bg-icoSignUpLayer" />
                <div className="scrollbar flex h-full flex-col overflow-x-hidden p-12">
                    <div className="flex items-center justify-between xl:pr-8">
                        <Iconosquare size={40} className="text-icoBlue" />
                        <div className="pl-5 text-icoGray-500">
                            <SwitchLanguage buttonStyle={NO_BACKGROUND_BLACK} />
                        </div>
                    </div>
                    <div className="m-auto w-full max-w-xs py-24">{children}</div>
                </div>
            </div>
        </div>
    );
};

export default LayoutSignIn;
